import axios from "./index";

const setAuthorizationHeaders = (token, domain) => {
  if (token) {
    axios.defaults.headers["sessiontoken"] =
      token || localStorage.getItem("sessionToken");
  }
  if (domain) {
    axios.defaults.headers["domain"] = domain || localStorage.getItem("domain");
  }
};
export default setAuthorizationHeaders;
